import React from 'react';
import { Grid, Paper, Typography, Box, Button, Container, Stack } from '@mui/material';
import { placement, careers, higherStudies, why, contact } from '../data';
import { Section, Heading, BulletList } from './common';

const card = { p: 4, height: '100%', border: '1px solid', borderColor: 'divider', borderRadius: '12px' };

const Careers = () => (
  <>
    <Section id="careers">
      <Heading title="Placements, careers and higher studies" text="A BPT degree is a foundation for patient care, rehabilitation, sports, research, teaching or private practice." />
      <Grid container spacing={4}>
        {[['Placement support', placement], ['Career opportunities after BPT', careers], ['Higher studies after BPT', higherStudies]].map(([t, items]) => (
          <Grid item xs={12} md={4} key={t}>
            <Paper elevation={0} sx={card}>
              <Typography variant="h5" sx={{ color: 'primary.dark', mb: 3 }}>{t}</Typography>
              <BulletList items={items} />
            </Paper>
          </Grid>
        ))}
      </Grid>
      <Typography sx={{ mt: 4, color: 'text.secondary' }}>
        Graduates can also work in other countries, depending on each country's licensing and registration requirements.
      </Typography>
    </Section>

    <Section bg="#ffffff">
      <Heading title="Why choose SBGI for BPT" />
      <Grid container spacing={4}>
        {why.map(([t, d]) => (
          <Grid item xs={12} sm={6} md={4} key={t}>
            <Box sx={{ borderLeft: '4px solid', borderColor: 'primary.main', pl: 2.5 }}>
              <Typography variant="h6" sx={{ color: 'primary.dark', mb: 1, fontSize: '1.15rem' }}>{t}</Typography>
              <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>{d}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Section>

    <Box component="section" id="contact" sx={{ bgcolor: 'secondary.main', py: { xs: 8, md: 11 }, scrollMarginTop: '72px' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={7}>
            <Typography variant="h2" sx={{ color: 'primary.dark', fontSize: { xs: '2.2rem', md: '3.2rem' }, lineHeight: 1.05, mb: 2 }}>
              Begin your journey in physiotherapy.
            </Typography>
            <Typography sx={{ color: 'primary.dark', fontSize: '1.1rem', lineHeight: 1.7, maxWidth: 560 }}>
              A career in physiotherapy means helping people move, recover and live better. Contact the admission office today to secure your seat.
            </Typography>
          </Grid>
          <Grid item xs={12} md={5}>
            <Stack spacing={2}>
              <Button href={`tel:${contact.phone.replace(/\s/g, '')}`} variant="contained" size="large" sx={{ bgcolor: 'primary.dark', color: '#fff', '&:hover': { bgcolor: '#082227' } }}>
                Call {contact.phone}
              </Button>
              <Button href={`mailto:${contact.email}`} variant="outlined" size="large" sx={{ color: 'primary.dark', borderColor: 'primary.dark', borderWidth: 2, '&:hover': { borderWidth: 2, bgcolor: 'rgba(11,46,53,0.08)' } }}>
                Email {contact.email}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  </>
);

export default Careers;
